window.addEventListener("hoContentLoaded", () => {
	Vue.component('lottie-inline',{
		mixins: [mixinViewport],
		data: function ()
		{
			return {
				data: null,
				block: null,
				inLoadingViewport: false,
				inViewport: false,
				loaded: false,
				initialized: false,
				animationData: null,
				type: null,
				animation: null,
				perc: -1,
				frameCount: 0,
				frame: 1,
				width: 0,
				height: 0,
				isTouch: (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0))
			}
		},
		methods: {
			scroll()
			{
				const viewport = this.viewport(this.$el);

				let top = 0;
				let bottom = top + window.innerHeight;
				let t = top - viewport.h * 1.5;
				let b = bottom + viewport.h * 1.5;

				//const setupLoading = ((t) < (viewport.t + window.innerHeight) && (b) > (viewport.y + viewport.h + window.innerHeight));
				let setupLoading = ((t) < (viewport.y) && (b) > (viewport.y + viewport.h));
				let inViewport = (t < viewport.y && b > (viewport.y + viewport.h));
				let p = (viewport.y+(viewport.h)) / ((window.innerHeight+(viewport.h)));

				if (setupLoading)
				{
					if (!this.inLoadingViewport)
					{
						this.inLoadingViewport = true;
						this.load();
					}
				}
				else
				{
					if (this.inLoadingViewport)
					{
						this.inLoadingViewport = false;
						this.dispose();
					}
				}

				if (setupLoading && inViewport)
				{
					let f = 1;

					if (p >= 0 && p <= 1)
					{
						if (this.perc !== p)
						{
							this.perc = 1-p;

							if (this.data.scrolling)
							{
								f = Math.round(this.frameCount * this.perc);

								if (this.frame !== f)
								{
									this.frame = f;
									this.animation.goToAndStop(f, true);
								}
							}
						}
					}
					else if (p <= 0)
					{
						f = this.frameCount - 1;

						if (this.frame !== f)
						{
							this.frame = f;
							this.animation.goToAndStop(f, true);
						}
					}
					else if (p >= 1)
					{
						f = 1;

						if (this.frame !== f)
						{
							this.frame = f;
							this.animation.goToAndStop(f, true);
						}
					}

					if (!this.inViewport)
					{
						this.inViewport = true;
						this.play();
					}
				}
				else
				{
					if (this.inViewport)
					{
						this.inViewport = false;
						this.stop();
					}
				}
			},

			gotoAndStop(perc)
			{
				const f = Math.round(this.frameCount * perc);

				if (this.frame !== f)
				{
					this.frame = f;
					this.animation.goToAndStop(f, true);
				}
			},

			sticky()
			{
				const item = this.block.querySelector(".block-lottie-sticky-fg");
				const viewport = this.viewport(item);

				let top = 0;
				let bottom = top + window.innerHeight;
				let t = top - viewport.h * 2;
				let b = bottom + viewport.h * 2;

				//const setupLoading = ((t) < (viewport.t + window.innerHeight) && (b) > (viewport.y + viewport.h + window.innerHeight));
				let setupLoading = ((t) < (viewport.y) && (b) > (viewport.y + viewport.h));
				let inViewport = (t < viewport.y && b > (viewport.y + viewport.h));
				let p = (viewport.y+(viewport.h)) / ((window.innerHeight+(viewport.h)));

				if (setupLoading)
				{
					if (!this.inLoadingViewport)
					{
						this.inLoadingViewport = true;
						this.load();
					}
				}
				else
				{
					if (this.inLoadingViewport)
					{
						this.inLoadingViewport = false;
						this.dispose();
					}
				}

				if (setupLoading && inViewport)
				{
					let f = 1;

					if (p >= 0 && p <= 1)
					{
						if (this.perc !== p)
						{
							this.perc = 1-p;

							if (this.data.scrolling)
							{
								f = Math.round(this.frameCount * this.perc);

								if (this.frame !== f)
								{
									this.frame = f;
									this.animation.goToAndStop(f, true);
								}
							}
						}
					}
					else if (p <= 0)
					{
						f = this.frameCount - 1;

						if (this.frame !== f)
						{
							this.frame = f;
							this.animation.goToAndStop(f, true);
						}
					}
					else if (p >= 1)
					{
						f = 1;

						if (this.frame !== f)
						{
							this.frame = f;
							this.animation.goToAndStop(f, true);
						}
					}

					if (!this.inViewport)
					{
						this.inViewport = true;
						this.play();
					}
				}
				else
				{
					if (this.inViewport)
					{
						this.inViewport = false;
						this.stop();
					}
				}
			},

			playOnce()
			{
				if (this.inViewport)
				{
					if (!this.inViewport)
					{
						this.inViewport = true;
						this.play();
					}
				}
				else
				{
					if (this.inViewport)
					{
						this.inViewport = false;
						this.stop();
					}
				}
			},

			loop()
			{
				if (this.inViewport)
				{

				}
				else
				{

				}
			},

			viewportIn()
			{
				switch(this.data.type)
				{
					case "play":
						this.loadAndPlay();
						break;
					case "loop":
						this.loadAndLoop();
						break;
				}
			},

			viewportOut()
			{
				switch(this.data.type)
				{
					case "play":
						this.dispose();
						break;
					case "loop":
						this.dispose();
						break;
				}
			},

			load()
			{
				this.frameCount = this.animationData.op;
				this.animation = bodymovin.loadAnimation({
					container: this.$refs.container, // Required
					animationData: this.animationData,
					path: this.data.path,
					renderer: this.data.renderer, // Required
					loop: this.data.loop, // Optional
					autoplay: false, // Optional
					rendererSettings: {
						preserveAspectRatio: 'none',
					}
				});

				this.animation.goToAndStop(this.frame, true);
			},

			loadAndPlay()
			{
				this.frameCount = this.animationData.op;
				this.animation = bodymovin.loadAnimation({
					container: this.$refs.container, // Required
					animationData: this.animationData,
					path: this.data.path,
					renderer: this.data.renderer, // Required
					loop: false, // Optional
					autoplay: true, // Optional
					rendererSettings: {
						preserveAspectRatio: 'none',
					}
				});
			},

			loadAndLoop()
			{
				this.frameCount = this.animationData.op;
				this.animation = bodymovin.loadAnimation({
					container: this.$refs.container, // Required
					animationData: this.animationData,
					path: this.data.path,
					renderer: this.data.renderer, // Required
					loop: true, // Optional
					autoplay: true, // Optional
					rendererSettings: {
						preserveAspectRatio: 'none',
					}
				});
			},

			play()
			{
				if (!this.data.scrolling)
				{
					if (this.animation)
						this.animation.play();
				}
			},

			stop()
			{
				if (!this.data.scrolling)
				{
					if (this.animation)
						this.animation.stop();
				}
			},

			dispose()
			{
				if (this.animation)
					this.animation.destroy();

				this.animation = null;
			},

			init()
			{
				this.initialized = false;

				console.log("LOAD:",this.data.path);

				try
				{
					fetch(this.data.path)
						.then(response => {
							if (!response.ok) {
								throw new Error("Network response was not ok " + response.statusText);
							}
							return response.json();
						})
						.then(data => {
							this.initialized = true;
							this.animationData = data;

							this.width = this.animationData.w;
							this.height = this.animationData.h;

							for (let i = 0; i < this.animationData.assets.length; i++)
							{
								this.animationData.assets[i].u = this.data.folder + "/images/";
							}

							if(this.data.type === "scroll")
							{
								this.animationFrameListen(this.scroll);
							}
							else if(this.data.type === "sticky")
							{
								this.animationFrameListen(this.sticky);
							}
							else
							{
								window.viewport.add(this);
							}

						})
						.catch(error => console.log(error));
				}
				catch (e)
				{
					console.log("PATH ERROR:", this.data.path);
				}
			},
		},

		beforeDestroy()
		{
			console.log("beforeDestroy");

			if(this.data.type === "sticky")
			{
				this.animationFrameListenKill(this.sticky);
			}

			if(this.data.type === "scroll")
			{
				this.animationFrameListenKill(this.scroll);
			}
		},

		mounted()
		{
			this.data = JSON.parse(this.$refs.data.innerHTML);
			this.block = this.$el.closest(".block");
			this.data.path = this.data.folder+"/data.json";

			console.log("mounted",this.data.path);

			this.init();
		}
	});
});
